import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import { tap } from 'rxjs/operators'
import { MatTableDataSource } from '@angular/material/table'
import { Store } from '@ngrx/store'
import { selectElementsState, selectFilterState, selectOrderPendingState } from '../orders.root.state'
import { Subscriptions } from '../../utils/subscriptions'
import { FilterActions } from '../states/filter/filter.actions'
import { OrderElement } from '../data/orderelement'
import { PendingState } from '../../account/account.root.state'
import { Observable } from 'rxjs'

class FilterObject {
  constructor(
    readonly typeValue: string, // nach spalte sortieren
    readonly statusValue: string, // sidnav filter
    readonly nameValue: string, //nach name sortieren
    readonly dateValue: string, //nach datum sortieren
  ) {}
}

export const tabGroupLabels = ['all', 'article', 'abo', 'digital content', 'event']

@Component({
  selector: 'cover-orders-dashboard',
  templateUrl: './orders-dashboard.component.html',
  styleUrls: ['./orders-dashboard.component.scss'],
})
export class OrdersDashboardComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscriptions = new Subscriptions(true)

  readonly pendingState = PendingState
  readonly today = new Date()
  threeMonthsPrior = new Date()
  sixMonthsPrior = new Date()
  twelveMonthsPrior = new Date()

  pending$: Observable<PendingState>

  ELEMENT_DATA!: OrderElement[]
  tabSelected = 0
  typeFilter = 'all'
  nameFilter = ''
  statusFilter = ''
  dateFilter = ''
  //sixMonthsPrior: Date = new Date()
  thirtyDaysPrior: Date = new Date()
  fourYearsPrior: number | undefined
  readonly dataSource: MatTableDataSource<OrderElement> = new MatTableDataSource<OrderElement>()
  readonly dataSourceArt: MatTableDataSource<OrderElement> = new MatTableDataSource<OrderElement>()
  readonly dataSourceSubscr: MatTableDataSource<OrderElement> = new MatTableDataSource<OrderElement>()
  index = 0
  readonly filterPredicate = (data: OrderElement, filter: string): boolean => {
    let orderDate
    let splitDate: string[]
    const filterObject = JSON.parse(filter)
    if (filterObject.typeValue == 'all') {
      if (
        (data.status.toLowerCase() == filterObject.statusValue &&
          data.name.toLowerCase().includes(filterObject.nameValue)) ||
        (filterObject.statusValue == '' && data.name.toLowerCase().includes(filterObject.nameValue))
      ) {
        if (filterObject.dateValue == '') {
          return true
        } else if (filterObject.dateValue == 'last6Months') {
          splitDate = data.startDate.split('.', 3)
          orderDate = new Date(parseInt(splitDate[2]), parseInt(splitDate[1]) - 1, parseInt(splitDate[0]))
          if (orderDate >= this.sixMonthsPrior) {
            return true
          }
        } else if (filterObject.dateValue == 'last30Days') {
          splitDate = data.startDate.split('.', 3)
          orderDate = new Date(parseInt(splitDate[2]), parseInt(splitDate[1]) - 1, parseInt(splitDate[0]))
          if (orderDate >= this.thirtyDaysPrior) {
            return true
          }
        } else if (data.startDate.includes(filterObject.dateValue)) {
          return true
        }
      }
    }
    // if (data.type == filterObject.typeValue) {
    //   if (
    //     (data.status.toLowerCase() == filterObject.statusValue &&
    //       data.name.toLowerCase().includes(filterObject.nameValue)) ||
    //     (filterObject.statusValue == '' && data.name.toLowerCase().includes(filterObject.nameValue))
    //   ) {
    //     if (filterObject.dateValue == '') {
    //       return true
    //     } else if (filterObject.dateValue == 'last6Months') {
    //       splitDate = data.date.split('.', 3)
    //       orderDate = new Date(parseInt(splitDate[2]), parseInt(splitDate[1]) - 1, parseInt(splitDate[0]))
    //       if (orderDate >= this.sixMonthsPrior) {
    //         return true
    //       }
    //     } else if (filterObject.dateValue == 'last30Days') {
    //       splitDate = data.date.split('.', 3)
    //       orderDate = new Date(parseInt(splitDate[2]), parseInt(splitDate[1]) - 1, parseInt(splitDate[0]))
    //       if (orderDate >= this.thirtyDaysPrior) {
    //         return true
    //       }
    //     } else if (data.date.includes(filterObject.dateValue)) {
    //       return true
    //     }
    //   }
    // }
    return false
  }

  @ViewChild('status') status!: ElementRef
  @ViewChild('date') date!: ElementRef
  @ViewChild('type') type!: ElementRef
  selectedStatus: string | undefined
  selectedOrderDate: string | undefined
  searchValue: string | undefined

  opened = false
  showTable: boolean = false

  constructor(private readonly logger: NGXLogger, private readonly store: Store) {
    this.pending$ = this.store.select(selectOrderPendingState)
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.showTable = this.isGreaterThanExtraSmall()
  }

  ngOnInit(): void {
    this.subscriptions.plusOne = this.store
      .select(selectElementsState)
      .pipe(
        tap(console.info),
        tap(state => {
          this.ELEMENT_DATA = state.element
          this.dataSource.data = this.ELEMENT_DATA
          this.dataSourceArt.data = this.ELEMENT_DATA.filter(element => element.type === 'ORDER').sort(
            this.orderSortingRule,
          )
          this.dataSourceSubscr.data = this.ELEMENT_DATA.filter(element => element.type !== 'ORDER').sort(
            this.orderSortingRule,
          )
        }),
      )
      .subscribe()

    this.dataSource.filterPredicate = this.dataSource.filterPredicate = (data, filter) => {
      let validStatus = true
      let validDate = true
      if (this.selectedStatus) {
        validStatus = this.selectedStatus === data.status
      }
      if (this.selectedOrderDate) {
      }
      return validStatus && validDate
    }

    this.showTable = this.isGreaterThanExtraSmall()

    this.dataSourceArt.filterPredicate = this.dataSource.filterPredicate
    this.dataSourceSubscr.filterPredicate = this.dataSource.filterPredicate

    this.dataSource.data = this.ELEMENT_DATA
    this.dataSourceArt.data = this.ELEMENT_DATA.filter(element => element.type === 'ORDER')
    this.dataSourceSubscr.data = this.ELEMENT_DATA.filter(element => element.type !== 'ORDER')

    this.threeMonthsPrior.setMonth(this.today.getMonth() - 3)
    this.sixMonthsPrior.setMonth(this.today.getMonth() - 6)
    this.twelveMonthsPrior.setMonth(this.today.getMonth() - 12)

    let today = new Date()

    this.thirtyDaysPrior = new Date(new Date().setDate(today.getDate() - 30))
    this.fourYearsPrior = today.getFullYear() - 3

    // INFO: look here
    this.subscriptions.plusOne = this.store
      .select(selectFilterState)
      .pipe(tap(state => this.logger.debug(state)))
      .subscribe(state => {
        this.dataSource.filter = JSON.stringify(new FilterObject(state.type, state.status, state.name, state.date))
        this.dataSourceSubscr.filter = JSON.stringify(
          new FilterObject(state.type, state.status, state.name, state.date),
        )
        this.dataSourceArt.filter = JSON.stringify(new FilterObject(state.type, state.status, state.name, state.date))

        this.typeFilter = state.type
        // if (state.type == 'article') {
        //   this.tabSelected = 1
        // } else if (state.type == 'abo') {
        //   this.tabSelected = 2
        // } else if (state.type == 'digital content') {
        //   this.tabSelected = 3
        // } else if (state.type == 'event') {
        //   this.tabSelected = 4
        // } else if (state.type == 'all') {
        //   this.tabSelected = 0
        // }
        // this.statusFilter = state.status
        // this.statusChanged(this.statusFilter)
        // this.dateFilter = state.date
        // this.dateChanged(this.dateFilter)
      })
  }

  orderSortingRule(a: OrderElement, b: OrderElement): number {
    // Provide a total order across multiple statuses, not just ACTIVE vs non-ACTIVE
    const priority: Record<string, number> = { ACTIVE: 0, ORDERED: 1, CANCELED: 2, INACTIVE: 3 }
    const pa = priority[a.status] ?? 99
    const pb = priority[b.status] ?? 99
    if (pa !== pb) {
      return pa - pb
    }

    // Tie-breaker 1: startDate (format dd.MM.yyyy) — newer first
    const parseDate = (s?: string): number => {
      if (!s) return 0
      const parts = s.split('.', 3)
      if (parts.length < 3) return 0
      const d = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))
      return isNaN(d.getTime()) ? 0 : d.getTime()
    }
    const ta = parseDate(a.startDate)
    const tb = parseDate(b.startDate)
    if (ta !== tb) {
      return tb - ta
    }

    // Tie-breaker 2: name A–Z for deterministic order
    const na = (a.name || '').toLowerCase()
    const nb = (b.name || '').toLowerCase()
    if (na < nb) return -1
    if (na > nb) return 1
    return 0
  }

  isGreaterThanExtraSmall(): boolean {
    return window.innerWidth > 768
  }

  // tabChanged(event: any): void {
  //   this.store.dispatch(FilterActions.changeTypeAction({ payload: tabGroupLabels[event.index] }))
  //   let label = tabGroupLabels[event.index]
  //   if (label == 'all') {
  //     label = 'Alle'
  //   }
  //   if (label == 'article') {
  //     label = 'Artikel'
  //   }
  //   if (label == 'abo') {
  //     label = 'Abo'
  //   }
  //   if (label == 'digital content') {
  //     label = 'Digitaler Content'
  //   }
  //   if (label == 'event') {
  //     label = 'Event'
  //   }
  //   this.type.nativeElement.innerHTML = label
  // }

  applyFilter(): void {
    this.dataSource.filterPredicate = (data, filter) => {
      let validStatus = true
      let validDate = true
      let validSearchString = true
      if (this.selectedStatus) {
        validStatus = this.selectedStatus === data.status
      }
      if (this.selectedOrderDate) {
        let splitDate = data.startDate.split('.', 3)
        let orderDate = new Date(parseInt(splitDate[2]), parseInt(splitDate[1]), parseInt(splitDate[0]))
        let filterDate: Date = this.today

        switch (this.selectedOrderDate) {
          case 'last3Months':
            filterDate = this.threeMonthsPrior
            break
          case 'last6Months':
            filterDate = this.sixMonthsPrior
            break
          case 'last12Months':
            filterDate = this.twelveMonthsPrior
            break
        }

        validDate = orderDate >= filterDate
      }

      if (this.searchValue) {
        validSearchString =
          data.name.toLowerCase().includes(this.searchValue.toLowerCase()) ||
          data.description.toLowerCase().includes(this.searchValue.toLowerCase())
      }
      return validStatus && validDate && validSearchString
    }

    this.dataSourceSubscr.filterPredicate = this.dataSource.filterPredicate
    this.dataSourceArt.filterPredicate = this.dataSource.filterPredicate

    this.dataSource.filter = 'applyFilter'
    this.dataSourceSubscr.filter = 'applyFilter'
    this.dataSourceArt.filter = 'applyFilter'
  }

  statusChanged(change: string): void {
    if (!change) {
      change = 'Alle'
    }
    if (change == 'ORDERED') {
      change = 'ORDERED'
    }
    if (change == 'ACTIVE') {
      change = 'ACTIVE'
    }
    if (change == 'CANCELED') {
      change = 'CANCELED'
    }
    if (change == 'INACTIVE') {
      change = 'INACTIVE'
    }

    this.status.nativeElement.innerHTML = change
  }

  dateChanged(change: string): void {
    if (!change) {
      change = 'Gesamter Zeitraum'
    }
    if (change == 'last30Days') {
      change = 'Letzte 30 Tage'
    }
    if (change == 'last6Months') {
      change = 'Letzte 6 Monate'
    }
    this.date.nativeElement.innerHTML = change
  }

  nameChanged(event: any): void {
    this.store.dispatch(
      FilterActions.changeNameAction({ payload: (event.target as HTMLInputElement).value.toLowerCase() }),
    )
  }

  filterReset(): void {
    this.store.dispatch(FilterActions.resetAction())
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
